import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AppConstants } from '../../app.constants';

@Component({
  selector: 'ness-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy {
  title: string = 'NESS';
  skipLinkPath: string;

  public get globalMsgDialog(): boolean {
    return AppConstants.showGlobalMsgDialog;
  }
  public set globalMsgDialog(b: boolean) {
    AppConstants.showGlobalMsgDialog = b;
  }

  private _unsubscribe$: Subject<void> = new Subject<void>();

  constructor(private router: Router, private elementRef: ElementRef) { }

  ngOnInit() {
    const url = this.router.url.split("#");
    this.skipLinkPath = `${ url[0] }#main`;
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  public showNav(evt: MouseEvent): void {
    let navEl: Element = this.elementRef.nativeElement.querySelector("#left-nav");
    if (!navEl.classList.contains('show')) {
      navEl.classList.add('show-pin');
    }
  }

  public hideNav(evt: MouseEvent): void {
    this.elementRef.nativeElement.querySelector("#left-nav").classList.remove('show-pin');
  }
}
